import React from 'react';
import PropTypes from 'prop-types';
import OrderStatus from 'orderStatusComponents/OrderStatus';
import {Link} from 'react-router-dom';
const WorkOrderHeader = (props) => {

    const {schedulingSystemDetail, orderId, orderStatus} = props;
    let orderStatusItem = null;
    let orderStatusDisplay = null;

    if (orderStatus) {

        const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

        if (orderStatusList) {
            orderStatusItem = orderStatusList.first();
        }

        if (orderStatusItem) {
            orderStatusDisplay = orderStatusItem.get('dispatchStatus');
        }

        if (orderStatus.get('loading')) {
            orderStatusDisplay = 'Loading...';
        }
    }

    if (!schedulingSystemDetail) {
        return null;
    }

    const labelStyle = {
        display: 'inline-block',
        textAlign: 'right',
        paddingRight: '5px'
    };

    const dataStyle = {
        paddingRight: '5px',
        display: 'inline-block'
    };

    return (
        <div className="center-align" style={{
            paddingTop: '5px'
        }}>

            <label style={labelStyle}>
                Order#:
            </label>
            <span style={dataStyle}>
                <Link to={`/work-order-detail/${orderId}`}>{orderId}</Link>
            </span>

            <label style={labelStyle}>
                TechId:</label>
            <span style={dataStyle}>
                {schedulingSystemDetail.getIn(['technicianId']) || 'N/A'}</span>

            <label style={labelStyle}>
                Status:</label>
            <span style={dataStyle}>
                <OrderStatus currentStatus={orderStatusDisplay}/></span>

        </div>

    );

};

WorkOrderHeader.propTypes = {
    schedulingSystemDetail: PropTypes.object,
    orderId: PropTypes.string,
    orderStatus: PropTypes.object
};

export default WorkOrderHeader;



// WEBPACK FOOTER //
// ./src/components/work-order/WorkOrderHeader.js